import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CreditCardMappingSearchModel} from "../credit-card-mapping-search.model";
import {CreditCardMappingEntityModel} from "../credit-card-mapping-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-credit-card-mapping-search-page",
    templateUrl: "./credit-card-mapping-search-page.component.html",
    providers: [provideSearchModel(CreditCardMappingSearchModel), provideEntityModel(CreditCardMappingEntityModel)]
})
export class CreditCardMappingSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
